import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_7f43311f from 'nuxt_plugin_plugin_7f43311f' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_recaptcha_5150fea4 from 'nuxt_plugin_recaptcha_5150fea4' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_libplugin036123a2_60852a6e from 'nuxt_plugin_libplugin036123a2_60852a6e' // Source: ./lib.plugin.036123a2.js (mode: 'client')
import nuxt_plugin_plugin_01899120 from 'nuxt_plugin_plugin_01899120' // Source: ./plugin.js (mode: 'all')
import nuxt_plugin_toast_03f71f64 from 'nuxt_plugin_toast_03f71f64' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_image_22cdcfb0 from 'nuxt_plugin_image_22cdcfb0' // Source: ./image.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_7e132f46 from 'nuxt_plugin_cookieuniversalnuxt_7e132f46' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_googleanalytics_62f99b5e from 'nuxt_plugin_googleanalytics_62f99b5e' // Source: ./google-analytics.js (mode: 'client')
import nuxt_plugin_yandexcacheguardclient_adc158dc from 'nuxt_plugin_yandexcacheguardclient_adc158dc' // Source: ../plugins/yandex-cache-guard.client.js (mode: 'client')
import nuxt_plugin_lazyimagesfixclient_154a9321 from 'nuxt_plugin_lazyimagesfixclient_154a9321' // Source: ../plugins/lazy-images-fix.client.js (mode: 'client')
import nuxt_plugin_chunkreloadclient_b28afae6 from 'nuxt_plugin_chunkreloadclient_b28afae6' // Source: ../plugins/chunk-reload.client.js (mode: 'client')
import nuxt_plugin_Vuelidate_384d8988 from 'nuxt_plugin_Vuelidate_384d8988' // Source: ../plugins/Vuelidate.js (mode: 'all')
import nuxt_plugin_vuerangeslider_3ee40530 from 'nuxt_plugin_vuerangeslider_3ee40530' // Source: ../plugins/vue-range-slider.js (mode: 'client')
import nuxt_plugin_fancyappsui_77c68acc from 'nuxt_plugin_fancyappsui_77c68acc' // Source: ../plugins/fancyapps-ui.js (mode: 'client')
import nuxt_plugin_vuemask_613243e6 from 'nuxt_plugin_vuemask_613243e6' // Source: ../plugins/vue-mask.js (mode: 'all')
import nuxt_plugin_phoneformat_7ac9284a from 'nuxt_plugin_phoneformat_7ac9284a' // Source: ../plugins/phone-format.js (mode: 'all')
import nuxt_plugin_numberformat_24c7baf3 from 'nuxt_plugin_numberformat_24c7baf3' // Source: ../plugins/number-format.js (mode: 'all')
import nuxt_plugin_casewords_209a4398 from 'nuxt_plugin_casewords_209a4398' // Source: ../plugins/case-words.js (mode: 'all')
import nuxt_plugin_getcookiesopt_11b12a60 from 'nuxt_plugin_getcookiesopt_11b12a60' // Source: ../plugins/get-cookies-opt.js (mode: 'all')
import nuxt_plugin_device_f02ba42c from 'nuxt_plugin_device_f02ba42c' // Source: ../plugins/device.js (mode: 'all')
import nuxt_plugin_additionalblockclasses_5807b000 from 'nuxt_plugin_additionalblockclasses_5807b000' // Source: ../plugins/additional-block-classes.js (mode: 'all')
import nuxt_plugin_yaglaaction_cb4d83f8 from 'nuxt_plugin_yaglaaction_cb4d83f8' // Source: ../plugins/yaglaaction.js (mode: 'all')
import nuxt_plugin_checkRoutes_6bfc6ddc from 'nuxt_plugin_checkRoutes_6bfc6ddc' // Source: ../plugins/checkRoutes.js (mode: 'all')
import nuxt_plugin_findcmsidbynavid_0493c38d from 'nuxt_plugin_findcmsidbynavid_0493c38d' // Source: ../plugins/find-cms-id-by-nav-id.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Транспортная компания - Central Trans","htmlAttrs":{"lang":"ru"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"metadescription","name":"description","content":""},{"hid":"geo-region","name":"geo.region","content":"RU-SVE"},{"hid":"geo-placename","name":"geo.placename","content":"Екатеринбург"},{"hid":"geo-position","name":"geo.position","content":"56.8519;60.6122"},{"hid":"geo-icbm","name":"ICBM","content":"56.8519, 60.6122"}],"link":[{"rel":"icon","type":"image\u002Fsvg+xml","href":"\u002Ffavicon.svg"},{"rel":"stylesheet","href":"\u002Fcss\u002Ffancybox.css"},{"rel":"preconnect","href":"https:\u002F\u002Fmc.yandex.ru","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Fwidget.novofon.ru"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fvpbx034305239.domru.biz"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fcdn.botfaqtor.ru"},{"rel":"dns-prefetch","href":"https:\u002F\u002Ftop-fwz1.mail.ru"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fwww.recaptcha.net"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fwww.gstatic.com"}],"script":[{"hid":"ld-organization","type":"application\u002Fld+json","json":{"@context":"https:\u002F\u002Fschema.org","@type":["Organization","MovingCompany"],"name":"Central Trans","alternateName":"Транспортная компания Central Trans","slogan":"Грузоперевозки по России и СНГ с 2010 года","description":"Транспортная компания Central Trans (Централ Транс) — грузоперевозки по России и странам СНГ с 2010 года: генеральные, негабаритные, тяжеловесные грузы, перегон техники из Китая, ЖД и мультимодальные перевозки. Собственный автопарк, страхование груза, расчёт стоимости за минуту.","url":"https:\u002F\u002Fcentraltrans.ru\u002F","knowsAbout":["Грузоперевозки","Негабаритные грузы","Тяжеловесные грузы","Перевозка спецтехники","Перегон техники из Китая","Железнодорожные перевозки","Мультимодальные перевозки","Перевозка ЖБИ","Контейнерные перевозки","Разрешения на перевозку негабарита"],"logo":{"@type":"ImageObject","url":"https:\u002F\u002Fcentraltrans.ru\u002Ffavicon.svg"},"email":"hello@centraltrans.ru","telephone":"+7 800 551 7490","foundingDate":"2010","address":{"@type":"PostalAddress","addressCountry":"RU","addressRegion":"Свердловская область","addressLocality":"Екатеринбург","postalCode":"620014","streetAddress":"ул. Хохрякова, 74, оф. 1001"},"geo":{"@type":"GeoCoordinates","latitude":56.8519,"longitude":60.6122},"openingHoursSpecification":[{"@type":"OpeningHoursSpecification","dayOfWeek":["Mo","Tu","We","Th","Fr"],"opens":"08:00","closes":"20:00"}],"areaServed":[{"@type":"Country","name":"Россия"},{"@type":"City","name":"Екатеринбург"},{"@type":"City","name":"Москва"},{"@type":"City","name":"Санкт-Петербург"},{"@type":"City","name":"Челябинск"},{"@type":"City","name":"Тюмень"},{"@type":"City","name":"Новосибирск"},{"@type":"City","name":"Казань"},{"@type":"City","name":"Нижний Новгород"},{"@type":"City","name":"Пермь"},{"@type":"City","name":"Уфа"},{"@type":"City","name":"Омск"},{"@type":"City","name":"Самара"},{"@type":"City","name":"Красноярск"},{"@type":"City","name":"Краснодар"},{"@type":"City","name":"Ростов-на-Дону"},{"@type":"City","name":"Воронеж"},{"@type":"City","name":"Волгоград"},{"@type":"City","name":"Сургут"},{"@type":"City","name":"Нижний Тагил"},{"@type":"Country","name":"Казахстан"},{"@type":"Country","name":"Беларусь"},{"@type":"Country","name":"Армения"},{"@type":"Country","name":"Грузия"},{"@type":"Country","name":"Узбекистан"},{"@type":"Country","name":"Киргизия"}],"sameAs":["https:\u002F\u002Ftelegram.me\u002Fcentraltranslogistics_bot","https:\u002F\u002Fwa.me\u002F79920029001"],"contactPoint":[{"@type":"ContactPoint","telephone":"+7 800 551 7490","contactType":"customer service","areaServed":"RU","availableLanguage":["ru"]}]}},{"hid":"ld-website","type":"application\u002Fld+json","json":{"@context":"https:\u002F\u002Fschema.org","@type":"WebSite","name":"Central Trans","alternateName":"Транспортная компания Central Trans","url":"https:\u002F\u002Fcentraltrans.ru\u002F","potentialAction":{"@type":"SearchAction","target":"https:\u002F\u002Fcentraltrans.ru\u002Fsearch?q={search_term_string}","query-input":"required name=search_term_string"}}},{"type":"text\u002Fjavascript","body":true,"src":"\u002Fjs\u002Fsourcebuster.min.js","async":true},{"type":"text\u002Fjavascript","body":false,"src":"https:\u002F\u002Fwidget.novofon.ru\u002Fnovofon.js?k=dqgTo_Akr6eLuRcI9HyXKyp_iU8BBhOH","async":true}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_7f43311f === 'function') {
    await nuxt_plugin_plugin_7f43311f(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_5150fea4 === 'function') {
    await nuxt_plugin_recaptcha_5150fea4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_libplugin036123a2_60852a6e === 'function') {
    await nuxt_plugin_libplugin036123a2_60852a6e(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_01899120 === 'function') {
    await nuxt_plugin_plugin_01899120(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_03f71f64 === 'function') {
    await nuxt_plugin_toast_03f71f64(app.context, inject)
  }

  if (typeof nuxt_plugin_image_22cdcfb0 === 'function') {
    await nuxt_plugin_image_22cdcfb0(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_7e132f46 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_7e132f46(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_62f99b5e === 'function') {
    await nuxt_plugin_googleanalytics_62f99b5e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_yandexcacheguardclient_adc158dc === 'function') {
    await nuxt_plugin_yandexcacheguardclient_adc158dc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lazyimagesfixclient_154a9321 === 'function') {
    await nuxt_plugin_lazyimagesfixclient_154a9321(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_chunkreloadclient_b28afae6 === 'function') {
    await nuxt_plugin_chunkreloadclient_b28afae6(app.context, inject)
  }

  if (typeof nuxt_plugin_Vuelidate_384d8988 === 'function') {
    await nuxt_plugin_Vuelidate_384d8988(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuerangeslider_3ee40530 === 'function') {
    await nuxt_plugin_vuerangeslider_3ee40530(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fancyappsui_77c68acc === 'function') {
    await nuxt_plugin_fancyappsui_77c68acc(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemask_613243e6 === 'function') {
    await nuxt_plugin_vuemask_613243e6(app.context, inject)
  }

  if (typeof nuxt_plugin_phoneformat_7ac9284a === 'function') {
    await nuxt_plugin_phoneformat_7ac9284a(app.context, inject)
  }

  if (typeof nuxt_plugin_numberformat_24c7baf3 === 'function') {
    await nuxt_plugin_numberformat_24c7baf3(app.context, inject)
  }

  if (typeof nuxt_plugin_casewords_209a4398 === 'function') {
    await nuxt_plugin_casewords_209a4398(app.context, inject)
  }

  if (typeof nuxt_plugin_getcookiesopt_11b12a60 === 'function') {
    await nuxt_plugin_getcookiesopt_11b12a60(app.context, inject)
  }

  if (typeof nuxt_plugin_device_f02ba42c === 'function') {
    await nuxt_plugin_device_f02ba42c(app.context, inject)
  }

  if (typeof nuxt_plugin_additionalblockclasses_5807b000 === 'function') {
    await nuxt_plugin_additionalblockclasses_5807b000(app.context, inject)
  }

  if (typeof nuxt_plugin_yaglaaction_cb4d83f8 === 'function') {
    await nuxt_plugin_yaglaaction_cb4d83f8(app.context, inject)
  }

  if (typeof nuxt_plugin_checkRoutes_6bfc6ddc === 'function') {
    await nuxt_plugin_checkRoutes_6bfc6ddc(app.context, inject)
  }

  if (typeof nuxt_plugin_findcmsidbynavid_0493c38d === 'function') {
    await nuxt_plugin_findcmsidbynavid_0493c38d(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
